module.exports = __webpack_public_path__ + "static/media/Elizar_main.2573bed1.jpg";